import React from "react";
import { Route, Navigate, useLocation } from "react-router-dom";
import { AuthConsumer, Service } from "../Authentication/AuthProvider";
import CustomSpinner from "./CustomSpinner";

const PrivateRoute = ({ children }) => {

  let location = useLocation();

  const { isAuthenticated } = Service;
  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return children;
};

export default PrivateRoute;